import { assign } from 'lodash';
import { createReducer } from '../util';
import { UPDATE_COMMENT_COUNT, UPDATE_CURRENT_PROJECT } from './action';
import { State } from './type';

const initialState: State = {
  commentCount: 0,
  currentProject: null,
};

export default createReducer(initialState, {
  [UPDATE_COMMENT_COUNT]: function (state: State, action: { payload: number }) {
    return assign({}, state, { commentCount: action.payload });
  },
  [UPDATE_CURRENT_PROJECT]: function (
    state: State,
    action: { payload: unknown },
  ) {
    return assign({}, state, { currentProject: action.payload });
  },
});
